import { Component, OnInit, ViewEncapsulation, inject } from "@angular/core";
import { Observable } from "rxjs";
import { CompProductFacade } from "../../services/comp-product-facade";
import { ProductFacade } from "../../services/product-facade";
import { ProductStepperComponent } from "../product-stepper/product-stepper.component";
import { CompProductStepperComponent } from "../comp-product-stepper/comp-product-stepper.component";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-stepper",
  templateUrl: "./stepper.component.html",
  imports: [ProductStepperComponent, CompProductStepperComponent, AsyncPipe],
})
export class StepperComponent {
  private compProductFacade = inject(CompProductFacade);
  private productFacade = inject(ProductFacade);

  showCompProduct$: Observable<boolean>;
  isSummaryStep$: Observable<boolean>;

  constructor() {
    const compProductFacade = this.compProductFacade;
    const productFacade = this.productFacade;

    this.showCompProduct$ = compProductFacade.showCompProduct$;
    this.isSummaryStep$ = productFacade.isSummaryStep$;
  }
}
